export class VehicleWebSocket {
    constructor(url, vehicleGidList, callback) {
        // 将vehicleGId添加到WebSocket连接URL中
        const wsUrl = `${url}&VehicleGIDList=${encodeURIComponent(vehicleGidList)}`;

        this.socket = new WebSocket(wsUrl);
        this.callback = callback;

        this.socket.onopen = () => {
            console.log(`WebSocket连接已建立，vehicleGidList: ${vehicleGidList}`);
        };

        this.socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            this.callback(data);
        };

        this.socket.onclose = () => {
            console.log('WebSocket连接已关闭');
        };

        this.socket.onerror = (error) => {
            console.error('WebSocket错误:', error);
        };
    }

    close() {
        this.socket.close();
    }
}